<template>
  <div class="app">
    <div class="Edit-base">
      <div class="title">编辑求职意向</div>
      <div class="Edit-content">
        <div class="content-box">
          <div class="box-item">
            <div class="item-title import">期望城市</div>
            <div class="item-content">
              <selectArea :name="'wantDqs'" :oldVal="post.wantCity" :oldTag="post.wantCity | toArea" :total="3"
                @changeWantDqs="wantCity">
              </selectArea>
            </div>
          </div>
          <div class="box-item">
            <div class="item-title import">期望薪资</div>
            <div class="item-content salary">
              <el-input placeholder="请输入期望薪资" size="small" maxlength="4" v-model="post.wantSalary" :disabled="isDis">
              </el-input>
              <el-checkbox v-model="isDis" size="medium" style="font-size: 14px;">面议</el-checkbox>
            </div>
          </div>
        </div>
        <div class="btn-box">
          <div class="box-item">
            <div class="item-content btn">
              <el-button @click="cancel">取消</el-button>
              <el-button type="primary" @click="save">保存</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updatewantJobInfo } from '@/request/api'
import selectArea from '@/components/selectArea2.vue'
export default {
  props: {
    val: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    selectArea,
  },
  data() {
    return {
      isDis: false, // 是否面议薪资
      other: '',
      post: {
        ID: '',
        username: '',
        wantCity: '', // 期望城市
        wantSalary: '', // 期望薪资
      }
    }
  },
  created() {
    this.post.ID = this.val.id
    this.post.wantCity = this.val.expectCity
    this.post.wantSalary = this.val.expectSalary
    this.post.username = JSON.parse(sessionStorage.getItem('LoginInfo')).username
    if (this.post.wantSalary === '0') {
      this.isDis = true
    } else {
      this.isDis = false
    }
  },
  methods: {
    wantCity(value) {
      this.post.wantCity = value
    },
    wantIndus(value) {
      this.post.wantIndustry = value
    },
    wantPosition(value) {
      this.post.wantJob = value
    },
    cancel() {
      this.$emit('wantJobShow', false)
    },
    isPostDataEmpty(post) {
      // 检查 post 对象中的每个属性是否为空
      for (let key in post) {
        if (post.hasOwnProperty(key) && post[key] === '') {
          // 如果发现空属性，返回 true
          return true
        }
      }
      // 如果所有属性都不为空，返回 false
      return false
    },
    textBetween(str, left_key, right_key) {
      var g_left = str.indexOf(left_key)
      if (g_left != -1) {
        g_left = g_left + left_key.length
        var g_right = str.indexOf(right_key, g_left)
      }
      if (g_right != -1) {
        return str.substr(g_left, g_right - g_left)
      }
    },
    async save() {
      if (this.isDis) {
        this.post.wantSalary = '0'
      }
      if (this.isPostDataEmpty(this.post)) {
        this.$message({
          message: '请完善数据后再提交！',
          type: 'warning'
        })
        return
      }

      this.post.ID = this.$route.query.resumeID;
      const { data: res } = await updatewantJobInfo(this.post);
      if (res.code === 200) {
        this.$emit('wantJobShow', true);
      } else {
        this.$message.warning(res.message);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app {
  background: #fff;
  padding: 20px;

  .Edit-base {
    background: #f4f5fb;
    padding: 20px;
    box-sizing: border-box;

    .title {
      font-size: 18px;
      color: #333;
      margin-bottom: 20px;
    }

    .Edit-content {
      width: 100%;

      .btn-box {
        text-align: right;

        .btn {
          display: flex;
          justify-content: right;
          padding-top: 20px;

          .el-button {
            width: 23%;
          }
        }
      }

      .content-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .box-item {
          width: 48%;
        }

        .item-title {
          font-size: 16px;
          color: #333;
          line-height: 40px;
        }

        .import::before {
          content: '*';
          color: #f56c6c;
          margin-right: 4px;
        }

        .item-content {
          margin-bottom: 10px;
        }

        .salary {
          display: flex;
          align-items: center;

          ::v-deep .el-checkbox {
            margin-left: 10px;

            .el-checkbox__inner {
              width: 20px;
              height: 20px;
            }

            .el-checkbox__inner::after {
              content: '';
              display: block;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(45deg);
            }

            .el-checkbox__label {
              font-size: 15px;
            }
          }

          ::v-deep .el-input {
            position: relative;
          }

          ::v-deep .el-input::before {
            content: 'K';
            position: absolute;
            color: #333;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
          }
        }


      }
    }
  }
}
</style>